<template>
  <email-schedule-form :data="emailSchedule"/>
</template>
<script>
import EmailScheduleForm from '@/views/admin/settings/Email/EmailScheduleForm'
import EmailScheduleService from '@/services/EmailScheduleService'
export default {
  components: {
    EmailScheduleForm
  },
  data() {
    return {
      emailSchedule: {}
    }
  },
  async mounted() {
    const { data } = await EmailScheduleService.getById(this.$route.params.id)
    this.emailSchedule = data
  }
}
</script>
<style>
</style>
